import { getConfigFor } from '../../../../utils/configService'
import { SPLIT_FEATURES } from '../../../../utils/constants/feature'
import { AnalyticsEvent } from '../../core/AnalyticsEvent'
import { BannerClickedEventSchema } from '../../schemas/banner/BannerClickedEventSchema'
import { CommonEventParams } from '../../utils/CommonParams'

export type BannerContentInterface = {
  source?: string | null
  campaignName?: string | null
  id?: string | null
  name?: string | null
  link?: string | null
  position?: number | null
  bannerType?: string | null
  type?: string | null
  destinationUrl?: string | null
  duration?: number | null
  redeemedStatus?: boolean | null
  dwellTime?: string | null
}

export interface BannerClickedEventParams extends CommonEventParams {
  BUSINESS_VERTICAL: string
  EVENT_CATEGORY: string
  CONTENT: BannerContentInterface
}

export class BannerClickedEvent extends AnalyticsEvent {
  constructor(params: BannerClickedEventParams) {
    super(BannerClickedEventSchema, ['segment'])
    this.createEventObject(params)
  }
}

export function trackBannerClickedEvent(params: BannerClickedEventParams) {
  const { isEnabled = false } =
    getConfigFor(SPLIT_FEATURES.LEAP_CDP_RELEASE_FIVE) || {}
  if (isEnabled) {
    new BannerClickedEvent(params).track()
  }
}
